<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title v-if="!isEdit" icon="mdi-movie-open-plus" :title="$t('SLIDER.DETAIL.SLIDER_ADD_TITLE')" :desc="$t('SLIDER.DETAIL.SLIDER_ADD_SUB_TITLE')" />
        <panel-title v-else icon="mdi-movie-open-plus" :title="$t('SLIDER.DETAIL.SLIDER_EDIT_TITLE')" :desc="$t('SLIDER.DETAIL.SLIDER_EDIT_SUB_TITLE')" />
      </v-col>
      <v-col cols="12" class="pt-1 pb-0">
        <v-chip label color="deep-purple darken-2" dark class="pl-1 pr-5 mb-2 rounded-l-lg rounded-r-xl">
          <v-icon class="mr-2">mdi-chevron-right</v-icon>
          <b>{{ $t("SLIDER.DETAIL.SLIDER_INFO_TITLE") }}</b>
        </v-chip>
        <p class="mb-0 text-caption grey--text text--darken-2">{{ $t("SLIDER.DETAIL.SLIDER_INFO_INFORMATION") }}</p>
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field v-model="sliderData.name" prepend-inner-icon="mdi-play-network" :label="$t('SLIDER.DETAIL.SLIDER_NAME_LABEL')" hide-details solo></v-text-field>
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field v-model="sliderData.desc" prepend-inner-icon="mdi-playlist-play" :label="$t('SLIDER.DETAIL.SLIDER_DESC_LABEL')" hide-details solo></v-text-field>
      </v-col>
      <v-col cols="12" class="pt-1 pb-0 mt-3">
        <div class="mb-2">
          <v-chip label color="deep-purple darken-2" dark class="pl-1 pr-5 mr-5 rounded-l-lg rounded-r-xl">
            <v-icon class="mr-2">mdi-chevron-right</v-icon>
            <b>{{ $t("SLIDER.DETAIL.SLIDER_ITEMS_TITLE") }}</b>
          </v-chip>
          <v-btn color="deep-purple darken-2" outlined rounded small dark @click="addItem">
            <v-icon left size="22">mdi-plus-circle-outline</v-icon>
            {{ $t("SLIDER.DETAIL.ADD_SLIDER_ITEM_BTN") }}
          </v-btn>
        </div>
        <p class="mb-0 text-caption grey--text text--darken-2">{{ $t("SLIDER.DETAIL.SLIDER_ITEMS_INFORMATION") }}</p>
      </v-col>
      <v-col cols="12">
        <draggable-effects :list="sliderData.items" class="col-12 px-0">
          <template v-slot="{ data, index }">
            <v-expansion-panels class="widget-item-group item-group mb-3">
              <v-expansion-panel class="widget-item">
                <v-expansion-panel-header class="py-0 pl-3">
                  <template>
                    <div>
                      <v-icon left color="deep-purple darken-2" size="25">mdi-drag-vertical</v-icon>
                      <v-chip color="deep-purple lighten-4" class="px-6 pr-3 mr-2" dark>
                        <span class="mr-2 deep-purple--text text--darken-4">{{ $t("SLIDER.DETAIL.SLIDER_ITEM") }}</span>
                        <v-sheet width="20" height="20" rounded color="deep-purple darken-2" class="white--text d-flex align-center justify-center rounded-circle ml-3">
                          <b>{{ index + 1 }}</b>
                        </v-sheet>
                      </v-chip>
                      <v-tooltip bottom color="red darken-2">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-show="sliderData.items.length > 1" v-on="on" v-bind="attrs" fab x-small color="red lighten-4" depressed @click="removeItem(index)">
                            <v-icon size="18" color="red darken-2">mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("SLIDER.DETAIL.REMOVE_SLIDER_ITEM") }}</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grey lighten-3">
                  <v-row no-padding>
                    <v-col cols="12" lg="6">
                      <div class="text-subtitle-2 mb-2">{{ $t("SLIDER.DETAIL.SLIDER_ITEM_CONTEN_TITLE") }}</div>
                      <v-text-field
                        solo
                        dense
                        hide-details
                        prepend-inner-icon="mdi-chevron-right"
                        :label="$t('SLIDER.DETAIL.SLIDER_ITEM_TITLE_LABEL')"
                        color="deep-purple"
                        class="mb-2"
                        v-model="data.title"
                      ></v-text-field>
                      <v-text-field
                        solo
                        dense
                        hide-details
                        prepend-inner-icon="mdi-chevron-right"
                        :label="$t('SLIDER.DETAIL.SLIDER_ITEM_SUB_TITLE_LABEL')"
                        color="deep-purple"
                        class="mb-2"
                        v-model="data.subTitle"
                      ></v-text-field>
                      <v-textarea
                        solo
                        prepend-inner-icon="mdi-chevron-right"
                        :label="$t('SLIDER.DETAIL.SLIDER_ITEM_DESC_LABEL')"
                        color="deep-purple"
                        dense
                        rows="3"
                        v-model="data.desc"
                      ></v-textarea>
                      <div class="d-flex flex-wrap justify-end">
                        <div class="mb-2 mb-mb-0">
                          <slider-button
                            :title="$t('SLIDER.DETAIL.SLIDER_ITEM_PRIMARY_BTN')"
                            :text.sync="data.primaryText"
                            :link.sync="data.primaryLink"
                            @text="data.primaryText = $event"
                            @link="data.primaryLink = $event"
                          />
                        </div>

                        <div class="mb-2 mb-mb-0">
                          <slider-button
                            :title="$t('SLIDER.DETAIL.SLIDER_ITEM_SECONDARY_BTN')"
                            :text.sync="data.secondaryText"
                            :link.sync="data.secondaryLink"
                            @text="data.secondaryText = $event"
                            @link="data.secondaryLink = $event"
                          />
                        </div>

                        <div class="mb-2 mb-mb-0">
                          <slider-button
                            :title="$t('SLIDER.DETAIL.SLIDER_ITEM_EXTRA_BTN')"
                            :text.sync="data.altText"
                            :link.sync="data.altLink"
                            @text="data.altText = $event"
                            @link="data.altLink = $event"
                          />
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" lg="6" class="d-flex align-center">
                      <div class="slider-image-wrapper">
                        <div class="viewer-container rounded-lg elevation-1">
                          <div v-ripple class="viewer-main" @click="selectImage(index)">
                            <div v-if="viewSrc[index] || data.media == ''">
                              <div v-if="data.media" class="slider-view-wrapper">
                                <v-img ref="imageView" :src="viewSrc[index]"></v-img>
                                <div class="viewer-hover">
                                  <div class="viewer-hover-wrapper">
                                    <p class="mb-0 title">
                                      <v-chip color="deep-purple dark" class="px-5 viewer-hover-chip" dark>
                                        <v-icon left>mdi-pencil</v-icon>
                                        {{ $t("SLIDER.DETAIL.SLIDER_ITEM_CHANGE_IMAGE") }}
                                      </v-chip>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <v-card elevation="1" class="d-flex justify-center align-center px-4 py-6" color="white lighten-3" :height="300" v-else>
                                <div>
                                  <p class="text-center title deep-purple--text text--darken-1 mb-0">
                                    <v-icon color="deep-purple" size="60" class="mb-3" left>mdi-gesture-tap</v-icon>
                                    <br />{{ $t("SLIDER.DETAIL.SLIDER_ITEM_IMAGE_NOT_SET") }}
                                  </p>
                                </div>
                              </v-card>
                            </div>
                            <v-card
                              elevation="1"
                              class="d-flex justify-center align-center px-4 py-6"
                              color="white lighten-3"
                              :height="300"
                              v-else-if="viewSrc[index] !== null"
                            >
                              <div>
                                <p class="text-center title deep-purple--text text--darken-1 mb-0">
                                  <v-progress-circular color="deep-purple" indeterminate :size="120" :width="7"></v-progress-circular>
                                  <br />
                                  <br />{{ $t("SLIDER.DETAIL.SLIDER_ITEM_LOADING_IMAGE") }}
                                </p>
                              </div>
                            </v-card>
                            <v-card elevation="1" class="d-flex justify-center align-center px-4 py-6" color="white lighten-3" :height="300" v-else>
                              <div>
                                <p class="text-center title red--text text--darken-1 mb-0">
                                  <v-icon color="red" size="60" class="mb-3" left>mdi-alert</v-icon>
                                  <br />
                                  <span v-html="$t('SLIDER.DETAIL.SLIDER_ITEM_IMAGE_ALERT')"> </span>
                                </p>
                              </div>
                            </v-card>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </draggable-effects>
      </v-col>
      <v-col cols="12">
        <v-btn v-if="!isEdit" color="success" class="px-6 mr-4" @click="sliderEkle" :loading="updateAddLoading">
          <v-icon left size="20">mdi-plus-box-multiple</v-icon>
          {{ $t("SLIDER.DETAIL.ADD_SLIDER_BTN") }}
        </v-btn>
        <v-btn v-else color="success" class="px-6 mr-4" @click="sliderGuncelle" :loading="updateAddLoading">
          <v-icon left size="20">mdi-rotate-left</v-icon>
          {{ $t("SLIDER.DETAIL.UPDATE_SLIDER_BTN") }}
        </v-btn>
        <v-btn color="red darken-2" outlined class="red lighten-4" @click="$router.back()">
          <v-icon left size="20">mdi-arrow-left</v-icon>
          {{ $t("SLIDER.DETAIL.CANCEL_BTN") }}
        </v-btn>
      </v-col>
    </v-row>
    <media-explorer v-model="explorer" @selected="getImage" format="images" :list-selection="false" :close-selection="true" />
  </v-container>
</template>

<script>
import DraggableEffects from "../../../components/Modules/Slider/DraggableEffects.vue";
import PanelTitle from "../../../components/PanelTitle.vue";
import MediaExplorer from "../../../components/Settings/Media/MediaExplorer.vue";
import SliderService from "../../../services/SliderService";
import SliderButton from "./SliderButton.vue";

export default {
  components: { PanelTitle, DraggableEffects, MediaExplorer, SliderButton },
  name: "SliderDetay",
  data: () => ({
    explorer: false,
    sliderData: {
      name: "",
      desc: "",
      items: [],
      code: ""
    },
    buttonMenus: [],
    sliderItem: {
      id: 1,
      title: "",
      media: "",
      subTitle: "",
      desc: "",
      primaryText: "",
      primaryLink: "",
      secondaryText: "",
      secondaryLink: "",
      altText: "",
      altLink: ""
    },
    id: 0,
    mediaSelect: "",
    viewSrc: [],
    updateAddLoading: false
  }),
  computed: {
    isEdit() {
      return !!this.$route.params.sliderID;
    }
  },
  methods: {
    setImage(key, img) {
      fetch(img).then(res => {
        if (res.status === 200) {
          this.$set(this.viewSrc, key, res.url);
        } else {
          this.$set(this.viewSrc, key, null);
        }
      });
    },
    convertUrl(imgName) {
      return `${this.$ApiUrl}images/${imgName}`;
    },
    getImage(img) {
      if (img) {
        this.sliderData.items[this.mediaSelect].media = img.name;
        fetch(this.convertUrl(img.name))
          .then(res => {
            if (res.status === 200) {
              return res.blob();
            } else {
              return null;
            }
          })
          .then(blob => {
            this.$set(this.viewSrc, this.mediaSelect, URL.createObjectURL(blob));
          });
      }
    },
    selectImage(index) {
      this.explorer = true;
      this.mediaSelect = index;
    },
    addItem() {
      ++this.id;
      this.sliderItem.id = Number(this.id);
      let item = JSON.parse(JSON.stringify(this.sliderItem));
      this.sliderData.items.push(item);
    },
    removeItem(index) {
      this.sliderData.items.splice(index, 1);
    },
    refleshIds() {
      this.id = 0;
      this.sliderData.items.forEach(item => {
        item.id = Number(++this.id);
      });
    },
    sliderEkle() {
      const sliderAdi = this.sliderData.name,
        sliderAciklamasi = this.sliderData.desc,
        gecisler = this.sliderData.items;
      this.updateAddLoading = true;
      SliderService.sliderEkle({ sliderAdi, sliderAciklamasi, gecisler })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("SLIDER.NOTIFY.SLIDER_ADD_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            let realPath = this.routerPath(1);
            this.$router.push(realPath);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.updateAddLoading = false;
        });
    },
    sliderGuncelle() {
      const sliderCode = this.sliderData.code,
        sliderAdi = this.sliderData.name,
        sliderAciklamasi = this.sliderData.desc,
        gecisler = this.sliderData.items;
      this.updateAddLoading = true;
      SliderService.sliderGuncelle({
        sliderCode,
        sliderAdi,
        sliderAciklamasi,
        gecisler
      })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("SLIDER.NOTIFY.SLIDER_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            let realPath = this.routerPath(2);
            this.$router.push(realPath);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.updateAddLoading = false;
        });
    },
    routerPath(num) {
      let path = this.$route.path.split("/");
      for (let i = 0; i < num; i++) {
        path.pop();
      }
      return path.join("/");
    }
  },
  created() {
    /**
     * Slider düzenleme ise düzenleme verisini düzene set et
     */
    if (this.$route.params.sliderID) {
      const sliderCode = Number(this.$route.params.sliderID);
      SliderService.sliderDetay(sliderCode).then(res => {
        if (res.status === 200) {
          let sliderDetay = res.data,
            items = [];
          sliderDetay.items.forEach((item, i) => {
            items[i] = {};
            let current = items[i],
              currentMedia = this.convertUrl(item.media);
            this.viewSrc[i] = currentMedia;
            this.setImage(i, currentMedia);
            current.id = Number(this.id++);
            current.title = item.name;
            current.media = item.media;
            current.subTitle = item.subtitle;
            current.desc = item.desc;
            current.primaryText = item.primarytext;
            current.primaryLink = item.primarylink;
            current.secondaryText = item.secondarytext;
            current.secondaryLink = item.secondarylink;
            current.altText = item.alttext;
            current.altLink = item.altlink;
            current.code = item.code;
            current.lang = item.lang;
          });
          sliderDetay.items = items;
          this.sliderData = { ...sliderDetay };
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          this.$router.back();
        }
      });
    }
  },
  mounted() {
    this.addItem();
  }
};
</script>

<style>
.viewer-main {
  cursor: pointer;
  user-select: none;
}

.viewer-hover-chip {
  cursor: pointer;
}

.viewer-container {
  position: relative;
  overflow: hidden;
}

.viewer-hover {
  opacity: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.582);
  transition: 0.5s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.viewer-container:hover .viewer-hover {
  opacity: 1;
}

.slider-image-wrapper {
  width: 100%;
  max-width: 100%;
}
</style>
